import { Component, OnInit, OnDestroy, Inject, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { FutureInfoService } from '../../_services/index';
import { FormDoneService } from '../../_services/form-done.service';
import { DOCUMENT } from '@angular/common';
import { PageScrollConfig, PageScrollService, PageScrollInstance } from 'ngx-page-scroll';
import {FileService} from '../../_services/file.service';
import {APP_CONFIG, IAppConfig} from '../../app.config';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css'],
  providers: [FutureInfoService, FormDoneService, FileService]
})

export class UserDashboardComponent implements OnInit, OnDestroy {
  public currentUser: any;
  public currentUserName: any;
  public getdataSub: Subscription;
  public pendingForm;
  public resumeEditForm;
  public color = 'accent';
  public mode = 'determinate';
  public completed = 50;
  public pending;
  public strokewidth = 15;
  public imgHeight;
  public imgwidth;
  public fileuploadSub: Subscription;
  public filepath;
  public loading: boolean;
  public fileSub: Subscription;
  successMessage: string;
  errorFlag = false;
  submitting = false;
  error = false;
  Application_available = [];
  Application_notstarted = [];
  Application_started = [];
  Application_completed = [];
  Application_review = [];
  Application_granted = [];
  Application_notgranted = [];
  domainname;
  @ViewChild('container')
  private container: ElementRef;

  constructor(
    @Inject(APP_CONFIG) private config: IAppConfig,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private api: FutureInfoService,
    private formapi: FormDoneService,
    private pageScrollService: PageScrollService,
    @Inject(DOCUMENT) private document: any,
    private _fileService: FileService) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    console.log(this.currentUser.firstname);
    this.currentUserName = this.currentUser.firstname + ' ' + this.currentUser.lastname;
  }

  ngOnInit() {
    this.domainname = this.config.domainname;
    this.handleUserUpdated();
    const pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, '.bodyWrapper');
    this.pageScrollService.start(pageScrollInstance);

    const element1 = document.querySelector('.droppable');
    this.makeDroppable(element1, this.callback, this);
    this.getApplications();
  }

  handleUserUpdated() {
    this.getdataSub = this.formapi.getFormData$()
    .subscribe(responsedata => {
      const formdata = responsedata.data; 
      console.log(formdata);
      this.completed = formdata.completed;
      this.pending = formdata.pending;
      if (formdata.full_path) {
        this.filepath = formdata.full_path;
      }
      if ((formdata.personalinformation === '0') || (formdata.personalinformation === null)) {
        this.pendingForm = '/profile/personal-information';
        this.resumeEditForm = 'Resume';
      } else if ((formdata.academicinformation === '0') || (formdata.academicinformation === null)) {
        this.pendingForm = '/profile/academic-information';
        this.resumeEditForm = 'Resume';
      } else if ((formdata.backgroundinformation === '0') || (formdata.backgroundinformation === null)) {
        this.pendingForm = '/profile/background-information';
        this.resumeEditForm = 'Resume';
      } else if ((formdata.priorhighereducation === '0') || (formdata.priorhighereducation === null)) {
        this.pendingForm = '/profile/prior-higher-education';
        this.resumeEditForm = 'Resume';
      } else if ((formdata.futurecollegeplans === '0') || (formdata.futurecollegeplans === null)) {
        this.pendingForm = '/profile/future-college-plans';
        this.resumeEditForm = 'Resume';
      } else if ((formdata.academiccareergoals === '0') || (formdata.academiccareergoals === null)) {
        this.pendingForm = '/profile/academic-career-goals';
        this.resumeEditForm = 'Resume';
      } else if ((formdata.extracurrucaullar === '0') || (formdata.extracurrucaullar === null)) {
        this.pendingForm = '/profile/extracurricular';
        this.resumeEditForm = 'Resume';
      } else if ((formdata.employment === '0') || (formdata.employment === null)) {
        this.pendingForm = '/profile/employment';
        this.resumeEditForm = 'Resume';
      } else {
        this.pendingForm = '/profile/personal-information';
        this.resumeEditForm = 'Edit';
      }
    });
  }

  makeDroppable(element, callback, classObj) {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.style.display = 'none';
    input.addEventListener('change', function (e) {
      triggerCallback(e, classObj);
    });
    element.appendChild(input);
    element.addEventListener('dragover', function(e) {
        e.preventDefault();
        e.stopPropagation();
        element.classList.add('dragover');
    });

    element.addEventListener('dragleave', function(e) {
        e.preventDefault();
        e.stopPropagation();
        element.classList.remove('dragover');
    });

    element.addEventListener('drop', function(e) {
        e.preventDefault();
        e.stopPropagation();
        element.classList.remove('dragover');
        triggerCallback(e, classObj);
    });

    element.addEventListener('click', function() {
        input.value = null;
        input.click();
    });

    function triggerCallback(e, obj) {
        let files;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        } else if (e.target) {
            files = e.target.files;
        }
        callback.call(null, files, e, obj);
    }
  }

  callback(files, event, classobject?: any) {
    classobject.loading = true;
    for (let i = 0; i < files.length; i++) {
      let ext = '';
      const mimeType = files[i].type;
      ext = files[i].name.split('.').pop();
      const allowedMIMEType = ['image/jpeg', 'image/png'];
      if (allowedMIMEType.indexOf(mimeType) >= 0 ) {
        if ((allowedMIMEType.indexOf(mimeType) === 0) || (allowedMIMEType.indexOf(mimeType) === 1) ) {
          classobject.filetype = ext;
        }else {
          classobject.filetype = ext;
        }
        const body = {
          attachableId: '',
          file: files[i],
          attachableType: 'Profilepic'
        };
        const file = files[i];
        const img = new Image();
        img.src = window.URL.createObjectURL( file );
        img.onload = function() {
          classobject.imgWidth = img.naturalWidth,
          classobject.imgHeight = img.naturalHeight;
          window.URL.revokeObjectURL( img.src );
          if (
            (classobject.imgWidth <= '580') &&
            (classobject.imgHeight <= '580') &&
            (classobject.imgWidth >= '200') &&
            (classobject.imgHeight >= '200')) {
              classobject.fileuploadSub = classobject._fileService.uploadFile(body).subscribe(
                responsedata => {
                  const filelink = JSON.parse(responsedata._body).data.filelink;
                  classobject.filepath = filelink;
                  classobject.loading = false;
                }, error => {
                  classobject.loading = false;
              });
            } else {
              alert('Image should be of dimensions between 200x200 to 580x580 or less');
            }
        };
      } else {
        alert('File not allowed');
        classobject.loading = false;
      }
    }

  }

  getApplications() {
    this.loading = true;
    this.submitting = true;
    this.fileSub = this._fileService.getApplications$()
    .subscribe(
      data => {
        this.error = false;
        this.submitting = false;
        const response = data;
        console.log(data.data);
        this.Application_available = data.data.notapplied;
        this.Application_notstarted = data.data.applied.notstarted;
        this.Application_started = data.data.applied.started;
        this.Application_completed = data.data.applied.completed;
        this.Application_review = data.data.applied.review;
        this.Application_granted = data.data.applied.granted;
        this.Application_notgranted = data.data.applied.notgranted;

      },
      error => {
        this.submitting = false;
        this.errorFlag = true;
        const errordata = JSON.parse(error._body);
        this.loading = false;
      },
    );
  }

  ngOnDestroy()  {
    if (this.fileSub)  {
      this.fileSub.unsubscribe();
    }
    if (this.fileuploadSub) {
      this.fileuploadSub.unsubscribe();
    }
    if (this.getdataSub) {
      this.getdataSub.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/user-dashboard/user-dashboard.component.ts